import React from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { Menu, Divider, Tooltip } from 'antd';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useSelector } from 'react-redux';
import { access, level } from '../../../common/Tool';
import { CapsuleTabs, JumboTabs } from 'antd-mobile';

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function CapsuleMenu({ path, menu }) {

    let navigate = useNavigate();
    const getLast = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array[loc_array.length - 1]
        if (!lst) return;
        return lst
    }
    const getBase = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array.slice(0, -1)
        return lst.join("/")
    }
    const last = getLast(path);
    const base = getBase(path);

    const role_by_id = useSelector(state => state.home.role_by_id);
    let _menu = level(menu, "", role_by_id)
    

    if (!menu || !menu.length) return (<></>);
    const l = (element, key) => {
        const icon = (element.icon) ? element.icon(element) : <></>;
        return (<CapsuleTabs.Tab
            title={element.name}
            description={icon}
            key={key}
            disabled={element.disabled}
        />);
        // return ({
        //     label: 
        //         (<div style={{ display: "flex", justifyContent: "space-between" }}>
        //             <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        //                 {element.name}
        //             </div>
        //         </div>),
        //     key: key,
        //     icon: icon,
        //     disabled: element.disabled,
        // }) 
    }
    const elements = menu.map((element, index) => {
        const key = element.uuid || element.key || index;
        if (element.hidden || element.unvisible) {
            return
        }
        if (element.component && access(element, role_by_id)) {
            return l(element, key)
        }
        if (element.href && access(element, role_by_id)) {
            return l(element, key)
        }
    })
    const change = (key) => {
        navigate(base + "/" + key)
    }
    return (<React.Fragment>
        {(_menu.length >= 2) && <CapsuleTabs
            activeKey={(last) ? last : undefined}
            defaultActiveKey={(last) ? last : undefined}
            onChange={change}
        >
            {elements}
        </CapsuleTabs>}
    </React.Fragment>

        // <Menu
        //     className={"menu-level-two"}
        //     mode="inline"
        //     defaultSelectedKeys={(last)?[last]:undefined}
        //     selectedKeys={(last)?[last]:undefined}
        //     style={{ border: "none", margin: "0px" }}
        //     inlineIndent={10}
        //     onClick={change}
        //     items={elements}
        // />
    )
}
